import {
    Component,
    input,
    output,
    ChangeDetectionStrategy,
} from '@angular/core';
import { NavItem } from '../navigation';
import { Router } from '@angular/router';
import {
    animate,
    state,
    style,
    transition,
    trigger,
} from '@angular/animations';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-menu-list-item',
    templateUrl: './menu-list-item.component.html',
    styleUrls: ['./menu-list-item.component.scss'],
    animations: [
        trigger('indicatorRotate', [
            state('collapsed', style({ transform: 'rotate(0deg)' })),
            state('expanded', style({ transform: 'rotate(180deg)' })),
            transition(
                'expanded <=> collapsed',
                animate('225ms cubic-bezier(0.4,0.0,0.2,1)'),
            ),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatIconModule, MatListModule, CommonModule],
})
export class MenuListItemComponent {
    expanded = false;

    readonly item = input<NavItem>();
    readonly depth = input(0);
    readonly navigated = output<NavItem>();

    constructor(public router: Router) {}

    onItemSelected(item?: NavItem) {
        if (item?.location) {
            location.href = item.location;
        }

        if (!item?.children?.length) {
            this.navigated.emit(item!);
            this.router.navigate([item?.route]);
        }
        if (item?.children && item.children.length) {
            this.expanded = !this.expanded;
        }
    }

    routeIsActive(): boolean {
        const item = this.item();
        return item?.route ? this.router.isActive(item.route, true) : false;
    }
}
